import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import {renderFieldCep, required} from '../../util/inputs';

import {alterarConfiguracaoBPe, cadastrarConfiguracaoBPe, buscarConfiguracoesBPe} from '../../actions/configuracao-bpe/configuracaoBPeActions';

import $ from 'jquery';
import {showSuccessMsg} from '../../util/messagesUtil';

export const validate = (values) => {
    const erros = {};
    if (!values.cep) {
        erros.cep = 'Campo obrigatório'
    }
    if (!values.logradouro) {
        erros.logradouro = 'Campo obrigatório'
    }
    if (!values.complemento) {
        erros.complemento = 'Complemento obrigatório.'
    }

    if (!values.numero) {
        erros.numero = 'Número obrigatório.'
    }

    if (!values.bairro) {
        erros.bairro = 'Bairro obrigatório.'
    }    

    if (!values.localidade) {
        erros.localidade = 'Localidade obrigatório.'
    }

    if (!values.uf) {
        erros.uf = 'UF obrigatório.'
    }

    if (!values.cidadeForm) {
        erros.cidadeForm = 'Cidade obrigatória.'
    }

    return erros
};


const renderField = ({
                         input,
                         label,
                         type,
                         css,
                         max,
                         readOnly,
                         meta: {touched, error}
                     }) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                   className={css}
                   maxLength={max}
                   id={input.name}
                   style={{borderColor: touched && error ? 'red' : ''}}
                   disabled={readOnly}
                   readOnly={readOnly}/>
            {touched
            && (error && <span style={{color: 'red'}}>{error}</span>)}
        </div>
    </div>
);


export class EnderecoConfiguracaoBPe extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);

        this.state = {
            mensagem: {tipo: '', texto: ''},
            usuario: null,
            tiposQualificacao: []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cidade !== this.props.cidade) {
            this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
                'cidadeForm', this.props.cidade);
        }
    }

    componentDidMount() {
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe', 'numero', 0);
      }

    fecharModal() {
        $('#modalCadastrarConfiguracaoBPe')
            .modal('hide');
        $('#modalCadastrarConfiguracaoBPe')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formularioCadastroEmpresa');
    }

    submit(values) {

        const parametros = this.props.montarParametroConfiguracao(values);

        const formData = new FormData();
        formData.append('file', new Blob([this.props.arquivo], {type: 'application/octet-stream'}), this.props.arquivo);
        formData.append('configuracaoBPe', new Blob([JSON.stringify(parametros)], {type: 'application/json'}));
        if (values.codigoConfiguracaoBPe) {
            this.props.alterarConfiguracaoBPe(formData).then(() => {
                showSuccessMsg('Configuração atualizada com sucesso');
                this.props.buscarConfiguracoesBPe(this.props.codigoEmpresaSelecionada);
                this.props.limparCampos();
                this.fecharModal();
            })
        } else {
            this.props.cadastrarConfiguracaoBPe(formData).then(() => {
                showSuccessMsg('Configuração cadastrada com sucesso');
                this.props.limparCampos();
                this.props.reset('formCadastrarConfiguracaoBPe');
                this.props.destroy();
                this.props.buscarConfiguracoesBPe(this.props.codigoEmpresaSelecionada);
                this.fecharModal();
            });
        }
    }

    // eslint-disable-next-line
    pesquisarPorCep(event) {
        const CEP = event.target.value.replace(/\D/g, '');
        if (CEP.length === 8) {
            const url = `${URL}/cep/public/${CEP}`;
            axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
                if (resp.status === 200) {
                    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
                        'logradouro', resp.data.logradouro);
                    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
                        'complemento', resp.data.complemento);
                    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
                        'bairro', resp.data.bairro);
                    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
                        'localidade', resp.data.localidade);
                    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
                        'uf', resp.data.uf);
                }
            })
        }
        this.limparCampos()
    }

    limparCampos() {
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'logradouro', '');
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'complemento', '');
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'bairro', '');
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'localidade', '');
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'uf', '');
    }


    limparMensagem() {
        this.setState({mensagem: undefined})
    }

    recuperaMensagem() {
        if (this.state.mensagem !== null && this.state.mensagem !== undefined) {
            if (this.state.mensagem.tipo === 'sucesso') {
                return (
                    <div className="alert alert-success col-md-12">
                        {this.state.mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                                onClick={() => {
                                    this.limparMensagem();
                                    this.setState({usuario: null})
                                }
                                }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
            if (this.state.mensagem.tipo === 'erro') {
                return (
                    <div className="alert alert-danger col-md-12">
                        {this.state.mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                                onClick={() => {
                                    this.limparMensagem();
                                }
                                }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
        }
        return ''
    }

    limparFormulario() {
        this.props.reset('formCadastrarConfiguracaoBPe');
        this.limparMensagem();
        this.removerImagem();
    }

    render() {
        const {
            handleSubmit, submitting, invalid, paginaAnterior
        } = this.props;
        return (

            <div className="modal-body">
                {this.recuperaMensagem()}
                <form onSubmit={handleSubmit(this.submit)}>
                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="cep" type="text" component={renderFieldCep} label="CEP:"
                                   css="form-control" readOnly={false} onChange={e => this.pesquisarPorCep(e)}/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-9 col-md-9">
                            <Field name="logradouro" type="text" component={renderField} label="Logradouro:"
                                   css="form-control" readOnly={false}/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-9 col-md-9">
                            <Field name="complemento" type="text" component={renderField} label="Complemento:"
                                   css="form-control" readOnly={false}/>
                        </div>
                        <div className="col-12 col-sm-9 col-md-3">
                            <Field name="numero" type="text" component={renderField} validate={[required]} label="Número:"
                                   css="form-control" readOnly={false}/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 mt-2">
                            <label>Cidade:</label>
                        </div>
                        <SelecaoCidadeAutocomplete name='Informe nome da cidade'
                                                   selecionarCidade={this.props.selecionarOrigem}
                                                   value={this.props.cidade}
                        />
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="bairro" type="text" component={renderField} label="Bairro:"
                                   css="form-control" readOnly={false}/>
                        </div>
                    </div>

                    <div className="form-group area-codigo">
                        <Field name="idEndereco" type="hidden" component={renderField} css="form-control col-md-12"/>
                        <Field name="cidadeForm" type="hidden" component={renderField} css="form-control col-md-12"/>
                    </div>
                    <div className="modal-footer">

                        <button className="btn btn-light" onClick={paginaAnterior}
                        >Voltar
                        </button>
                        <button type="submit" disabled={invalid || submitting}
                                className="btn btn-laranja">Avançar
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export const mapStateToProps = state => (
    {
        cidadeForm: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'cidadeForm'),
    });

export default connect(mapStateToProps,
    {
        changeFieldValue,
        alterarConfiguracaoBPe,
        cadastrarConfiguracaoBPe,
        buscarConfiguracoesBPe
    })(reduxForm({
    form: 'formCadastrarConfiguracaoBPe',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
})(EnderecoConfiguracaoBPe));
